<script setup lang="ts">
import type { WithClassAsProps } from './interface';

import { cn } from '@/utils';

import { useCarousel } from './useCarousel';

defineOptions({
	inheritAttrs: false
});

const props = defineProps<WithClassAsProps>();

const { carouselRef, orientation } = useCarousel();
</script>

<template>
	<div ref="carouselRef" :class="cn('h-full overflow-hidden', mainClass)">
		<div
			:class="
				cn('flex', orientation === 'horizontal' ? '' : 'flex-col', props.class)
			"
			v-bind="$attrs"
		>
			<slot></slot>
		</div>
	</div>
</template>
